var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1808 30.0787C59.1808 28.1004 59.0154 26.1113 58.6625 24.165H30.3535V35.3722H46.5647C45.892 38.9867 43.7305 42.1842 40.5655 44.216V51.4878H50.2371C55.9165 46.4189 59.1808 38.9333 59.1808 30.0787Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3534 58.5128C38.448 58.5128 45.2743 55.9356 50.248 51.4869L40.5764 44.2151C37.8855 45.9903 34.4117 46.9955 30.3644 46.9955C22.5345 46.9955 15.8956 41.8732 13.5136 34.9863H3.5332V42.4827C8.62816 52.3104 19.0055 58.5128 30.3534 58.5128Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5018 34.987C12.2446 31.3725 12.2446 27.4586 13.5018 23.844V16.3477H3.53246C-0.724362 24.5712 -0.724362 34.2599 3.53246 42.4834L13.5018 34.987Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3534 11.8239C34.6323 11.7598 38.7678 13.3211 41.8667 16.187L50.4354 7.8779C45.0097 2.93734 37.8083 0.221098 30.3534 0.306649C19.0055 0.306649 8.62816 6.50909 3.5332 16.3474L13.5025 23.8438C15.8736 16.9463 22.5235 11.8239 30.3534 11.8239Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.2fe06825.svg";
export { ForwardRef as ReactComponent };